module.exports = __webpack_public_path__ + "images/memo_emoji.png";